import React from 'react'
import { I18n } from 'react-redux-i18n'

const TermPolicy = ({ isLightMode }) => {
    const basePStyle = {
        textAlign: 'center',
    };

    const pStyle = isLightMode 
        ? { ...basePStyle, fontSize: '16px', color: '#98A2B3', marginTop: '25px' }
        : { ...basePStyle, fontSize: '14px', color: '#FFFFFF', marginTop: '20px' };

    const aStyle = isLightMode 
        ? {}
        : { color: '#FFFFFF', textDecoration: 'underline' };

    return (
        <p style={pStyle}>
            {I18n.t('signup.agreeToTerms')}{' '}
            <a
                style={aStyle}
                href="https://www.goodjourney.io/en/terms"
                target="_blank"
                rel="noopener noreferrer"
            >
                {I18n.t('signup.termsOfService')}
            </a>{' '}
            {I18n.t('signup.and')}{' '}
            <a
                style={aStyle}
                href="https://www.goodjourney.io/en/policy"
                target="_blank"
                rel="noopener noreferrer"
            >
                {I18n.t('signup.privacyPolicy')}
            </a>
        </p>
    );
};

export default TermPolicy